import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  const lastUpdatedDate = "2025"; // <-- CHANGE THIS

  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {/* Page Title */}
        <h1 className="text-4xl font-bold text-gray-800">Privacy Policy</h1>
        <p className="text-gray-500">
          <strong>Last updated:</strong> {lastUpdatedDate}
        </p>

        {/* Introduction */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">1. Introduction</h2>
          <p className="text-gray-600">
            Pure Clean Shopping ("us", "we", or "our") operates the <Link to="/" className="text-blue-600 hover:text-blue-700">purecleanshopping.info</Link> website (the "Service"). 
            This page informs you of our policies regarding the collection, use, and disclosure of personal data 
            when you use our Service and the choices you have associated with that data.
          </p>
        </section>

        {/* Information We Collect */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">2. Information We Collect</h2>
          <p className="text-gray-600">
            We collect several different types of information for various purposes to provide and improve our Service to you.
          </p>
          <h3 className="text-xl font-medium text-gray-700 mt-2">Types of Data Collected</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>
              <strong>Personal Data:</strong> While using our Service, we may ask you to provide certain personally identifiable information 
              that can be used to contact or identify you ("Personal Data"). This may include: Email address, First name and last name, 
              Phone number, Address, etc.
            </li>
            <li>
              <strong>Usage Data:</strong> Information on how the Service is accessed and used ("Usage Data"), such as IP address, browser type, 
              pages visited, visit time and date, time spent, and other diagnostic data.
            </li>
            <li>
              <strong>Cookies:</strong> We use cookies and similar tracking technologies to track activity on our Service. 
              You can instruct your browser to refuse cookies, but some Service features may not work without them.
            </li>
          </ul>
        </section>

        {/* How We Use Your Information */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">3. How We Use Your Information</h2>
          <p className="text-gray-600">
            Pure Clean Shopping uses the collected data for various purposes:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To allow you to participate in interactive features of our Service when you choose</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information to improve our Service</li>
            <li>To monitor the usage of our Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </section>

        {/* Your Data Protection Rights */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">4. Your Data Protection Rights</h2>
          <p className="text-gray-600">
            You have certain data protection rights. We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal Data.
          </p>
        </section>

        {/* Contact Us */}
        <section className="space-y-4">
          <h2 className="text-2xl font-semibold text-gray-700">5. Contact Us</h2>
          <p className="text-gray-600">
            If you have any questions about this Privacy Policy, please contact us by email: 
            <a href="mailto:contact@purecleanshopping.info" className="text-indigo-600 hover:underline"> contact@purecleanshopping.info</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
